const demystifyingPredictiveAnalytics = [
  {
    type: "paragraph",
    text: "Statistically, you are likely to have seen over 40 ads in the last 10 minutes. But how many of them can you actually recall? Though getting the message out is vital to finding new customers and to growing a business, with so much competition to capture consumers’ dwindling attention spans, it is easy for an advertisement to get lost in a deluge of content. As physical and digital spaces get clogged with marketing content, consumers begin to tune out; this term now even has a name: banner blindness. To avoid this and to save time, money and effort on marketing is by targeting your advertising towards customers who are most likely to react to it. This is where predictive analytics can help.",
  },

  {
    type: "heading",
    text: "What is Predictive Analytics?",
  },
  {
    type: "paragraph",
    text: "Simply put, Predictive Analytics is the process of using data from past events to forecast the likelihood of future events. When people spend time online they leave traces of their activity on public databases and social networks. By piecing together this data, computer programs can find patterns in past behavior, reveal preferences and create profiles to forecast how they will behave in the future.",
  },
  {
    type: "paragraph",
    text: "Going through massive amounts of data to find useful insights requires powerful software and setting up such predictive analytics software will initially cost both time and money. However, once setup, it will allow you to automate the process of collecting the data and give you more time to actually act on it.",
  },

  {
    type: "paragraph",
    text: "Here are a few ways in which companies can benefit from Predictive Analytics.",
  },

  {
    type: "heading",
    text: "Finding new customers",
  },
  {
    type: "paragraph",
    text: "Increasing your customer base is vital to your company’s growth and also one of the hardest parts of marketing. Maximizing the response from your ad campaign can help save your company money. However, rather than opting for a bigger and louder ad campaign, targeting prospects using predictive analytics can deliver better returns on investment. Research has shown that millennials lose interest in advertisements after only five seconds. Thus, businesses that are better informed through predictive analytics can target potential customers with content and offers specially tailored for them and can cut through the noise. It is well-known that customers are more likely to engage with content that is specifically relevant to them.",
  },
  {
    type: "paragraph",
    text: "Information provided on past sales can be used to categorize prospective customers based on demographics and other data. By collecting and analyzing data about customers’ browsing and transaction history, software can be trained to learn when a customer is most likely to engage with a company or purchase a certain product. This can be used to target consumers that are most likely to buy, rather than chasing prospects that you know little or nothing about.",
  },

  {
    type: "heading",
    text: "Holding on to existing customers",
  },
  {
    type: "paragraph",
    text: "It is no secret that a long term customer is more valuable than a one-time customer. It also costs much less to keep a current customer than it does to acquire a new one. However, a study has shown that between 60 and 80 percent of customers did not return to do business with a company with which they were initially satisfied. By staying connected and building a one-on-one relationship with every customer, businesses can help translate one-time sales into a lifetime of customer value.",
  },

  {
    type: "heading",
    text: "Reducing churn",
  },
  {
    type: "paragraph",
    text: "A survey found that while 80 percent of executives believed they had delivered a “superior experience” to their customers, customers felt that only 8 percent of companies were really doing so. Predictive Analytics allows companies to keep track of customer satisfaction levels and find patterns in the behavior of customers who leave or move away from regular purchases. This data can be used to identify other customers who exhibit the risk of churning. These at-risk customers can then be persuaded to stay on with personalized email marketing campaigns that address their specific issues.",
  },

  {
    type: "heading",
    text: "Selling more to existing customers",
  },
  {
    type: "paragraph",
    text: "It can be hard for marketers to get into the mindset of their target audiences but with data it becomes easier to understand what your customers find most compelling about a product, detect when they may need to reorder certain products or even find other products they might be interested in. Predictive Analytics can match up customers to the offers most suited to them and learn when the optimal time is to send out offers.",
  },

  {
    type: "heading",
    text: "Conclusion",
  },
  {
    type: "paragraph",
    text: "By taking out the guesswork and manual labor involved in understanding your consumers, Predictive Analytics can ease your marketing process. It gives you a bigger and better toolbox to determine what your customer’s next move will likely be and gives you the time and space to deliver the perfect response.",
  },
];

export default demystifyingPredictiveAnalytics;
